import React from "react";
import { RenderErrorFallback } from "./RenderErrorFallback";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    const label = this.props.label || "Render error";
    if (typeof console !== "undefined" && console.error) {
      console.error(label, error, info);
    }
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <RenderErrorFallback
          variant={this.props.variant || "inline"}
          title={this.props.title}
          message={this.props.message}
        />
      );
    }
    return this.props.children;
  }
}
